var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.66602H7.33333C6.97971 2.66602 6.64057 2.80649 6.39052 3.05654C6.14048 3.30659 6 3.64573 6 3.99935V19.9993C6 20.353 6.14048 20.6921 6.39052 20.9422C6.64057 21.1922 6.97971 21.3327 7.33333 21.3327H16.6667C17.0203 21.3327 17.3594 21.1922 17.6095 20.9422C17.8595 20.6921 18 20.353 18 19.9993V3.99935C18 3.64573 17.8595 3.30659 17.6095 3.05654C17.3594 2.80649 17.0203 2.66602 16.6667 2.66602ZM12.6667 19.9993H11.3333V18.666H12.6667V19.9993ZM7.33333 17.3327V3.99935H16.6667V17.3327H7.33333Z",
    className: "fill",
    fill: "#726863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9f5a371788f5feeccc900e8e605035fe.svg";
export { ForwardRef as ReactComponent };